import React from "react";
import { TableRow, TableCell, Tooltip, IconButton, Box } from "@mui/material";
import { Icon } from "@fluentui/react/lib/Icon";
import { UnconfiguredRules } from "system/types/interfaces";

interface NotConfiguredRowProps {
  item: UnconfiguredRules;
  onAdd: (ruleName: string) => void;
  readOnlyViewer: boolean;
}

export const NotConfiguredRow: React.FC<NotConfiguredRowProps> = ({ item, onAdd, readOnlyViewer }) => {
  return (
    <TableRow hover>
      <TableCell align="left" sx={{ width: "50px" }}>
        <Box
          sx={{
            display: "flex",
            gap: "8px",
            justifyContent: "flex-start",
          }}
        >
          <Tooltip title="Add to Configured">
            <IconButton size="small" color="primary" onClick={() => onAdd(item.name)} hidden={readOnlyViewer}>
              <Icon iconName="Add" />
            </IconButton>
          </Tooltip>
        </Box>
      </TableCell>

      <TableCell sx={{ color: "#fff", padding: "15px 16px" }}>{item.name}</TableCell>
      <TableCell sx={{ color: "#fff" }}>{item.defaultValue}</TableCell>

      <TableCell sx={{ color: "#fff" }}>
        {item.description}
      </TableCell>
    </TableRow>
  );
};
